'use client';

// Third Party
import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import moment from 'moment';
import 'react-dates/initialize';
import { DayPickerRangeController, DayPickerRangeControllerShape, FocusedInputShape } from 'react-dates';

// Utils
import { isSearchDayOutsideRange } from '@utils/booking-lead-time';
export type { FocusedInputShape };
export interface SearchDateRange {
  checkInDate: string | null;
  checkOutDate: string | null;
}
export interface SearchDateRangePickerProps extends SearchDateRange {
  onDatesChange: (range: SearchDateRange) => void;
  focusedInput: FocusedInputShape | null;
  onFocusChange: (focusedInput: FocusedInputShape | null) => void;
  /**
   * The union is the two configurations any search surface has ever wanted, so
   * a third asks for a type change and a conversation instead of shipping a
   * layout nobody looked at.
   */
  numberOfMonths?: 1 | 2;
}

// react-dates resolves its own copy of React's JSX types, which do not unify
// with ours. This cast is the single place that reconciles them.
const DayPicker = DayPickerRangeController as React.ComponentType<DayPickerRangeControllerShape>;
const toMoment = (date: string | null): moment.Moment | null => date ? moment(date) : null;
const toDateString = (date: moment.Moment | null): string | null => date ? date.format('YYYY-MM-DD') : null;
export const SearchDateRangePicker: React.FC<SearchDateRangePickerProps> = t0 => {
  const $ = _c(13);
  const {
    checkInDate,
    checkOutDate,
    onDatesChange,
    focusedInput,
    onFocusChange,
    numberOfMonths: t1
  } = t0;
  const numberOfMonths = t1 === undefined ? 2 : t1;
  let t2;
  if ($[0] !== onDatesChange) {
    t2 = t3 => {
      const {
        startDate,
        endDate
      } = t3;
      return onDatesChange({
        checkInDate: toDateString(startDate),
        checkOutDate: toDateString(endDate)
      });
    };
    $[0] = onDatesChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== checkInDate) {
    t3 = toMoment(checkInDate);
    $[2] = checkInDate;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== checkOutDate) {
    t4 = toMoment(checkOutDate);
    $[4] = checkOutDate;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== focusedInput || $[7] !== numberOfMonths || $[8] !== onFocusChange || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
    t5 = <DayPicker verticalBorderSpacing={0} enableOutsideDays={false} minDate={null} noBorder={true} minimumNights={1} numberOfMonths={numberOfMonths} initialVisibleMonth={null} focusedInput={focusedInput} onDatesChange={t2} onFocusChange={onFocusChange} startDate={t3} endDate={t4} isOutsideRange={isSearchDayOutsideRange} hideKeyboardShortcutsPanel={true} />;
    $[6] = focusedInput;
    $[7] = numberOfMonths;
    $[8] = onFocusChange;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};